<script setup>
import { useStore } from 'vuex';

const props = defineProps({
    data: Object,
    editable: Boolean
});

const store = useStore();

const removeItem = () => {
    store.dispatch('cart_products/delete', props.data);
};
</script>

<template>
    <div class="border-b border-gray-300 relative py-4 pt-8 my-4 mr-1 overflow-hidden">
        <div class="flex flex-wrap gap-4 justify-between px-2">
            <div class="w-2/12 text-blue-dark inline-flex items-center shrink-0">
                <img :alt="$translate(data.product.name)" class="w-auto max-h-12" :src="data.product.image.replace('.png', '-gradient.png')" />
            </div>
            <div class="flex-1 min-w-0 flex flex-wrap gap-2 items-start">
                <div class="flex-1 min-w-[200px]">
                    <strong class="text-xs">
                        {{ $translate(data.product.name) }}
                    </strong>

                    <div>
                        <span class="attribute text-xs" v-for="productAttributeValue in data.productVariant.productAttributeValues.data" :key="productAttributeValue.id">
                            {{ $translate(productAttributeValue.title) }}
                        </span>
                    </div>
                    <div v-if="data.productVariant.discount_percent !== 0">
                        <span v-if="data.productVariant.discount_runtime !== null" class="attribute text-xs">
                            {{ $t('runtime_discount') }} {{ data.productVariant.discount_runtime * 100 }} %
                        </span>
                        <span v-else class="attribute text-xs"> {{ $t('runtime_discount') }} {{ data.productVariant.discount_percent * 100 }} % </span>
                    </div>

                    <div v-if="data.productVariant.discountText">
                        <span class="attribute text-xs">
                            {{ $translate(data.productVariant.discountText) }}
                        </span>
                    </div>
                </div>
                <div class="text-right mt-1 ml-auto pr-1">
                    <strong class="text-xs block">
                        {{ $toCurrency(data.productVariant.total_price_gross) }}
                    </strong>
                </div>
            </div>
            <button
                v-if="editable"
                @click="removeItem"
                aria-label="close popup"
                class="absolute top-0 right-0 w-8 h-8 bg-white rounded-full shadow-md flex items-center justify-center z-10 text-blue-dark hover:bg-gray-100 transition"
            >
                <Icon type="Close" viewBox="0 0 26 26" width="10" height="10" class="shrink-0 fill-current" />
            </button>
        </div>
        <slot></slot>
    </div>
</template>

<style scoped>
.attribute:not(:first-of-type)::before {
    content: '•';
    margin: 0 5px;
}
</style>
